import { SEO } from '@/components/SEO';

export function ContactPage() {
  return (
    <article className="max-w-3xl mx-auto px-4 pt-12 pb-20 sm:pt-16 aces-prose">
      <SEO
        title="Contact ACES"
        description="How to reach the ACES team — corrections, content suggestions, partnership enquiries."
        canonical="https://acescommerce.com/contact/"
      />
      <h1>Contact</h1>
      <p>
        ACES is a small, focused project. We read everything sent our way and reply within a working week.
      </p>
      <p>
        <strong>Email:</strong>{' '}
        <a href="mailto:hello@acescommerce.com" className="text-accent-600 underline">hello@acescommerce.com</a>
      </p>

      <h2>Corrections &amp; missing content</h2>
      <p>
        Spotted an arithmetic error, an unclear explanation, or a chapter missing from your syllabus? Email
        us — please include the chapter URL and the specific issue.
      </p>
      <p>
        <a href="mailto:hello@acescommerce.com" className="text-accent-600 underline">hello@acescommerce.com</a>
      </p>

      <h2>Teachers &amp; parents</h2>
      <p>
        If you want to use ACES in a classroom or recommend it to a study group, you don&rsquo;t need permission.
        Share the URL freely. Printable PDF notes are available for selected chapters on the Notes tab of each chapter page.
      </p>

      <h2>Press &amp; partnerships</h2>
      <p>
        Journalists, school administrators, and curriculum publishers welcome.
        <br />
        <a href="mailto:hello@acescommerce.com" className="text-accent-600 underline">hello@acescommerce.com</a>
      </p>

      <h2>Privacy &amp; legal</h2>
      <p>
        For privacy enquiries or legal matters, email{' '}
        <a href="mailto:hello@acescommerce.com" className="text-accent-600 underline">hello@acescommerce.com</a>.
      </p>

      <hr />

      <p className="text-sm text-ink-500">
        ACES is an independent learning platform and is not affiliated with NCERT, CBSE, the Government of
        Kerala, or any school board.
      </p>
    </article>
  );
}
